import type { ZFieldMeta } from "./ZFilterApiTypes";

export type ZFilterSearchFieldType = ZFieldMeta["fieldType"];
export type ZFilterSearchOrder = "ASC" | "DESC";

export const filterSearchOrder: Record<ZFilterSearchOrder, ZFilterSearchOrder> =
  {
    ASC: "ASC",
    DESC: "DESC",
  };

export const defaultFilterSearchFieldType: ZFilterSearchFieldType = "SYSTEM";

export type ZFilterSearchSortItem = {
  field: string;
  fieldType: ZFilterSearchFieldType;
  order: ZFilterSearchOrder;
};
